import React from 'react';
import PropTypes from 'prop-types';

import { ViewportProvider } from './ViewportProvider';
import ViewportWrapper from './ViewportWrapper';

function Viewport ({ onClose, visible, loading }) {
  return (
    <ViewportProvider>
      {visible
        ? (<ViewportWrapper loading={loading} onClose={onClose} />)
        : null}
    </ViewportProvider>
  );
}

Viewport.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  loading: PropTypes.bool
};

export default Viewport;
